import './App.css';
import React, { useState, useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import "bootstrap/dist/css/bootstrap.min.css";
import 'antd/dist/reset.css';
import './assets/styles/Theme.scss';
import './assets/styles/CustomTheme.scss';
import './assets/styles/TableTheme.scss';
import './assets/styles/app.scss';
import LayoutScreen from './components/LayoutScreen';
import ProjectList from './components/Project/ProjectList';
import ProjectDetail from './components/Project/ProjectDetail';
import Entitlement from './components/administration/Entitlement';
import ProjectSettings from './components/Project/ProjectSettings';
import { useSelector } from 'react-redux';
import Dashboard from './components/Dashboard';
import LandingLayoutFile from './components/landingPage/LandingLayoutFile';
import HomePage from './components/landingPage/HomePage';
import ConfigurationSetting from './components/ConfigurationSettings/ConfigurationSetting';
import CompanyProfile from './components/CompanyProfile';
import DocumentManager from './components/DocumentManager/DocumentManager';
import TemplateManager from './components/TemplateManager';
import WorkflowManager from './components/WorkflowManager';
import IssueTracking from './components/IssueTracking';
import Report from './components/Report';
import PortfolioManagement from './components/PortfolioManagement';

function App() {
  const {loginInfo} = useSelector((state)=>state.auth);
  let isAuth = localStorage?.getItem("token1");

  return (
    <Routes>
      <Route exact path="/" element={<LandingLayoutFile><HomePage/></LandingLayoutFile>} />
      <Route exact path="/login" element={<Login/>} />
      {isAuth||loginInfo?<>
      <Route exact path='/dashboard' element={<LayoutScreen><Dashboard/></LayoutScreen>}></Route>
      <Route exact path='/project-list' element={<LayoutScreen><ProjectList/></LayoutScreen>}></Route>
      <Route exact path='/project-settings' element={<LayoutScreen><ProjectSettings/></LayoutScreen>}/>
      <Route exact path="/project-detail" element={<LayoutScreen><ProjectDetail/></LayoutScreen>}/>
      <Route exact path='/security' element={<LayoutScreen><Entitlement/></LayoutScreen>}/>
      <Route exact path='/settings' element={<LayoutScreen><ConfigurationSetting/></LayoutScreen>}/>
      <Route exact path='/company-profile' element={<LayoutScreen><CompanyProfile/></LayoutScreen>}/>
      <Route exact path='/document-manager' element={<LayoutScreen><DocumentManager/></LayoutScreen>}/>
      <Route exact path='/template-manager' element={<LayoutScreen><TemplateManager/></LayoutScreen>}/>
      <Route exact path='/workflow-manager' element={<LayoutScreen><WorkflowManager/></LayoutScreen>}/>
      <Route exact path='/issue-tracking' element={<LayoutScreen><IssueTracking/></LayoutScreen>}/>
      <Route exact path='/reports' element={<LayoutScreen><Report/></LayoutScreen>}/>
      <Route exact path='/portfolio-management' element={<LayoutScreen><PortfolioManagement/></LayoutScreen>}/>
      
       </> 
      : <Route path="*" element={<Navigate replace to="/login" />}/>} 
      {/* <Route path="/loginpage" element={<Navigate replace to="/login" />}/> */}
    </Routes>
  );
}

export default App;
